module.exports = __webpack_public_path__ + "static/media/icons.bc3fd188.svg";